module.exports = __webpack_public_path__ + "img/ajxq_09.22295084.jpg";